/* src/app/private/components/sales-mail-hub/mail-left-actions/mail-left-actions.component.scss */
/*# sourceMappingURL=mail-left-actions.component.css.map */
